// Shared formatting helpers for the overtime module.

export function fmtMoney(n) {
  const v = Number(n || 0);
  return v.toLocaleString('en-US', {
    style: 'currency', currency: 'USD',
    minimumFractionDigits: 0, maximumFractionDigits: 0,
  });
}

export function fmtMoneyExact(n) {
  const v = Number(n || 0);
  return v.toLocaleString('en-US', {
    style: 'currency', currency: 'USD',
    minimumFractionDigits: 2, maximumFractionDigits: 2,
  });
}

export function fmtHours(n) {
  const v = Number(n || 0);
  return v.toLocaleString('en-US', { maximumFractionDigits: 1 });
}

export function fmtNumber(n) {
  return Number(n || 0).toLocaleString('en-US');
}

export function fmtDate(d) {
  if (!d) return '—';
  // Dates arrive as YYYY-MM-DD (or ISO); render as M/D/YYYY without TZ drift.
  const s = String(d).slice(0, 10);
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (m) return `${+m[2]}/${+m[3]}/${m[1]}`;
  return s;
}
